import { render, staticRenderFns } from "./WizardFooter.vue?vue&type=template&id=18839450"
import script from "./WizardFooter.vue?vue&type=script&lang=ts"
export * from "./WizardFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports